import React, { useState, useEffect } from 'react';
import { Checkbox, Space } from 'antd';
import ConfirmationModal from '../../CustomComponents/ConfirmationModal';
import {
  ColumnSettingsContainer,
  ColumnCheckboxItem,
  ResetButton
} from '../JobList/styledComponents';

const DEFAULT_COLUMNS = {
  jobId: true,
  author: true,
  patientName: true,
  submissionTime: true,
  effectiveDate: false,
  facility: false,
  biller: false,
  currentAssignee: false,
  workType: false,
  dictationTemplate: false,
  submissionToReviewerLevel1Time: false,
  rejectedByReviewerTime: false,
  billedTime: false,
  emrSubmissionTime: false,
  cptCodes: false,
  scribe: false,
  status: true,
  riskAssessment: false,
  patientType: false,
  admissionDate: false,
  mrn: false,
  dischargeDate: false,
  primaryCarePhysician: false
};

const COLUMN_CONFIG = [
  { key: 'jobId', label: 'Job ID', mandatory: true },
  { key: 'author', label: 'Author' },
  { key: 'patientName', label: 'Patient Name' },
  { key: 'submissionTime', label: 'Submitted Time' },
  { key: 'status', label: 'Status' },
  { key: 'effectiveDate', label: 'Encounter Date' },
  { key: 'facility', label: 'Facility' },
  { key: 'biller', label: 'Biller' },
  { key: 'currentAssignee', label: 'Current Assignee' },
  { key: 'workType', label: 'Work Type' },
  { key: 'dictationTemplate', label: 'Template' },
  {
    key: 'submissionToReviewerLevel1Time',
    label: 'Submission Time to Reviewer'
  },
  { key: 'rejectedByReviewerTime', label: 'Reviewer Rejected Time' },
  { key: 'billedTime', label: 'Billed Time' },
  { key: 'emrSubmissionTime', label: 'EMR Submission Time' },
  { key: 'cptCodes', label: 'CPT Codes', emrUnbilledOnly: true },
  { key: 'scribe', label: 'Scribe' },
  { key: 'riskAssessment', label: 'Risk Assessment' },
  { key: 'patientType', label: 'Patient Type' },
  { key: 'admissionDate', label: 'Admission Date' },
  { key: 'mrn', label: 'MRN' },
  { key: 'dischargeDate', label: 'Discharge Date' },
  { key: 'primaryCarePhysician', label: 'Primary Care Physician' }
];

export { DEFAULT_COLUMNS };

const NotesBoardColumnSettingsModal = ({
  visible,
  onCancel,
  onSave,
  visibleColumns
}) => {
  const [tempColumns, setTempColumns] = useState(visibleColumns);

  useEffect(() => {
    setTempColumns(visibleColumns);
  }, [visibleColumns]);

  const handleToggle = key => {
    const column = COLUMN_CONFIG.find(c => c.key === key);
    if (!column?.mandatory) {
      setTempColumns(prev => ({ ...prev, [key]: !prev[key] }));
    }
  };

  const handleCancel = () => {
    setTempColumns(visibleColumns);
    onCancel();
  };

  const handleSave = () => {
    onSave(tempColumns);
    onCancel();
  };

  const handleReset = () => {
    setTempColumns(DEFAULT_COLUMNS);
  };

  return (
    <ConfirmationModal
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSave}
      header='Customize Columns'
      confirmation={true}
      antdModalProps={{ centered: true, width: 450, closable: false }}
    >
      <ColumnSettingsContainer>
        <Space direction='vertical' size='middle' style={{ width: '100%' }}>
          {COLUMN_CONFIG.map(column => (
            <ColumnCheckboxItem key={column.key}>
              <Checkbox
                checked={tempColumns[column.key]}
                onChange={() => handleToggle(column.key)}
                disabled={column.mandatory}
              >
                {column.label}
                {column.mandatory && (
                  <span style={{ color: '#999' }}> (Required)</span>
                )}
              </Checkbox>
            </ColumnCheckboxItem>
          ))}
        </Space>
        <ResetButton onClick={handleReset}>Reset to Default</ResetButton>
      </ColumnSettingsContainer>
    </ConfirmationModal>
  );
};

export default NotesBoardColumnSettingsModal;
